const Modal = require('./modal');
const template = require('./card-preview.tpl').default;
const CardDetailService = require('../../services').Cards;

module.exports = DomClass(template, function CardPreview() {

	var _t = this;

	var fields = ['name', 'type', 'text', 'image'];
	if (this.target) {
		fields.forEach(function(field) {
			_t[field] = _t.target[field];
		});
	}

	Modal.call(this.card);

	this.onclick = function() {
		this.card.open();
	};

});
